import isArray from "lodash/isArray";
import type { Menu } from "@/services/user/type";
import useUserStore from "@/stores/useUserStore";
import type { PropsWithChildren } from "react";

function recursionMenus(menus: Menu[] = [], authSet: Set<string>) {
  menus.forEach((x) => {
    authSet.add(x.key);
    if (isArray(x.routes)) {
      recursionMenus(x.routes, authSet);
    }
  });
}

export function getAuthSet(menus: Menu[] = []): Set<string> {
  const authSet = new Set<string>();

  recursionMenus(menus, authSet);

  return authSet;
}

export const useAuth = (key: string) => {
  const { authSet } = useUserStore();

  return authSet.has(key);
};

export const Auth = (props: PropsWithChildren<{ authKey: string }>) => {
  const { authKey } = props;
  const { authSet } = useUserStore();

  return authSet.has(authKey) ? props.children : null;
};
